interface IAdLogging {
  campaign_id: string;
  goods_sno: number;
  list_id: string;
  parameters: string;
}
export enum AdAction {
  DISPLAY = 'display',
  CLICK = 'click',
  LIKE = 'like',
  UNLIKE = 'unlike',
}
export interface AdLog extends IAdLogging {
  log_id: string;
  action: AdAction;
  occurred_at: string;
}
